import React from "react";
import PropTypes from "prop-types";
import { cn } from "../../../helpers/utils/css-utils";

const TextBox = ({
  id,
  type,
  name,
  value,
  placeholder,
  onChange,
  ...props
}) => {
  return (
    <input
      id={id}
      type={type}
      name={name}
      onChange={onChange}
      placeholder={placeholder}
      value={value}
      className={cn(
        `block h-10 w-full rounded-xl border border-gray-200 bg-gray-50/80 px-3.5 text-sm text-gray-900
         placeholder:text-gray-400 transition-all duration-200
         hover:border-gray-300 focus:bg-white focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/10

`,
        {
          "border-red-400 text-red-900 placeholder-red-400 focus:border-red-500 focus:ring-red-500/20 dark:border-red-500 dark:text-red-400":
            props?.error,
        }
      )}
      {...props}
    />
  );
};

export default TextBox;

TextBox.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
};
